import React, { Component } from 'react';
import { Utils } from '../../utils/Utils';
import { Cos } from '../../utils/Cos';
import { ReplayAction } from './ReplayActionBuilder';
import { WebRTC } from '../../utils/WebRTC';
import lottie from 'lottie-web';
// import $ from 'jquery';

/**
 * cid=1_1_1&page=2
 *
 * 技术文档
 * http://putaoabc-inc.com:8081/xwiki/bin/view/Main/RD/%E4%B8%BB%E8%AF%BE%E5%AE%9E%E7%8E%B0%E7%9B%B8%E5%85%B3/%E6%8A%80%E6%9C%AF%E7%BB%86%E8%8A%82%E6%95%B4%E7%90%86/%E5%85%B3%E4%BA%8E%E8%AF%AD%E9%9F%B3%E4%BA%A4%E4%BA%92%E6%8C%87%E4%BB%A4%E5%92%8C%E5%88%A4%E5%8D%B7%E7%9A%84%E8%B0%83%E6%95%B4-20181228/
 * http://putaoabc-inc.com:8081/xwiki/bin/view/Main/RD/%E4%B8%BB%E8%AF%BE%E5%AE%9E%E7%8E%B0%E7%9B%B8%E5%85%B3/%E6%8A%80%E6%9C%AF%E7%BB%86%E8%8A%82%E6%95%B4%E7%90%86/%E5%85%B3%E4%BA%8E%E8%91%A1%E8%90%84%E8%AF%AD%E9%9F%B3%E6%9C%8D%E5%8A%A1%E7%9A%84%E4%BD%BF%E7%94%A8%E5%92%8C%E6%B5%8B%E8%AF%95%E8%AF%B4%E6%98%8E/
 */

let recorder;
let reqUrl = window.location.origin;
if (reqUrl.indexOf("aibingo.com.cn") > -1) {
    reqUrl = reqUrl;
} else if (reqUrl.indexOf("putaoabc.com") === -1) {
    reqUrl = "https://www.putaoabc.com";
}

window.actionID;

class ASRandJudge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parentNode: props.parentNode,
            currStarCount: props.currStarCount,
            currSubjectCount: props.currSubjectCount,
            arsJudgeStatus: 0, //1-录音中；2-录音结束
            asrComplete: false, //完成语音交互，收起背景，跟读(repeat)要标绿，会等2s在收起
            volumnWave: [], //存放声音波形
            markGreen: false,
            speechResultMiddle_Hit: [], //标绿和抖动数组
            showFlower: false,
        };
        // this.timeoutInterval = null;
        // const answer = props.item && props.item.detail && props.item.detail.answer ? props.item.detail.answer : "";
        this.obtainRecordInterval = null;
        this.maxVolumnTimer = null;
        this.avgVolumnTimer = null;
        this.minVolumn = 8; //answer.length / 2 + 5;    //最小声音分贝要求(不是真正的分贝)，字母越多，要求平均分贝越高
        this.volumnState = -1; //0-开始静音状态；1-有声音状态；2-有声音后又静音2s的状态/主动点击完成了
        this.cid = Utils.getHashQueryString('cid');
        this.putaoid = Utils.getCookie('putaoid') || 0;
        this.token = Utils.getCookie('token');
        this.uuid = Utils.getCookie('uuid') || 0;
        this.judgeFunction = props.item && props.item.detail && props.item.detail.judgeFunction ? props.item.detail.judgeFunction : null;
        this.showText = props.item && props.item.detail && props.item.detail.showText ? props.item.detail.showText : '';
        this.maxTime = props.item && props.item.detail && props.item.detail.countdown ? props.item.detail.countdown : 8;
        this.speechServices2 = props.item && props.item.detail && props.item.detail.speechServices2 ? props.item.detail.speechServices2 : null;
        this.answers =
            props.item && props.item.detail && props.item.detail.answerDetail2 && props.item.detail.answerDetail2.answers
                ? props.item.detail.answerDetail2.answers
                : null;
        this.answerDetail =
            props.item && props.item.detail && props.item.detail.answerDetail2
                ? JSON.stringify(props.item.detail.answerDetail2)
                : props.item.detail.answer2
                    ? props.item.detail.answer2
                    : props.item.detail.answer;
        this.replayKeyNum = 2; //录屏的key，默认有一个 begin和feedback，因此默认是2，每次调用一下ReplayAction.add，就加1
        this.startReacordTime = 0;
        this.answerTime = 0;
        this.roundNum = 1;  // 第几轮
        this.endAsrStop = false;    // 尾端静音结束
        this.speechResultMiddle_totalHit = null;    // speechService总的标绿情况
        this.speechResultMiddle = "";   // 葡萄语音识别结果
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            parentNode: nextProps.parentNode,
            currStarCount: nextProps.currStarCount,
            currSubjectCount: nextProps.currSubjectCount,
        });
    }

    componentWillMount() {
        this.removeAsrSay();
    }

    /**
     * timeout 倒计时总时间
     * countdown 快结束的动画
     */
    componentDidMount() {
        const that = this;
        if (window.withXunFeiASR !== 1) {
            that.speechServices2 = [...that.speechServices2].filter(x => {
                return x.serverName !== "xunfeiASR"
            });
        }
        that.startRecording();
    }

    componentWillUnmount() {
        // clearInterval(this.timeoutInterval);
        clearInterval(this.maxVolumnTimer);
        this.clearAnimation();
    }

    removeAsrSay() {
        const asrSay = document.getElementById('asrSay');
        if (asrSay && asrSay.parentNode) {
            asrSay.parentNode.removeChild(asrSay);
        }
    }

    clearAnimation() {
        let playAnimation = document.getElementById('playAnimation');
        if (playAnimation) {
            playAnimation.innerHTML = ''; //清空动画容器
            playAnimation.setAttribute('class', 'hide'); //清空动画容器
            playAnimation.style.top = 0;
            playAnimation.style.left = 0;
        }
    }

    handleAsrComplate(smileNum, callback) {
        const that = this;
        if (that.showText && smileNum > -1) {
            that.showSmileNum(smileNum, () => {
                that.setState({
                    asrComplete: true, //跟读的标红标绿，2s结束
                }, () => {
                    callback();
                });
            });
        } else {
            callback();
        }
    }

    showSmileNum(smileNum, callback) {
        const that = this;
        setTimeout(() => {
            that.setState({
                showFlower: true,
            }, () => {
                let playAnimation = document.getElementById('playAnimation');
                playAnimation.removeAttribute('class');
                lottie.loadAnimation({
                    container: playAnimation,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: `${window.animationUrl}flower${smileNum}/flower${smileNum}.json`,
                });
                //播放音频
                let hasPlayMp3 = false;
                let hasPlayTimer = null;
                let playAsrAudio = document.getElementById('playAsrAudio');
                if (playAsrAudio) {
                    hasPlayTimer = setTimeout(() => {
                        if (!hasPlayMp3) {
                            that.clearAnimation();
                            callback();
                        }
                    }, 7000); //3多花是6s，多加1s
                    playAsrAudio.setAttribute('src', `${window.animationUrl}flower${smileNum}/flower${smileNum}.mp3`);
                    playAsrAudio.onended = () => {
                        hasPlayMp3 = true;
                        clearTimeout(hasPlayTimer);
                        that.clearAnimation();
                        callback();
                    };
                }
            });
        }, 2000);
    }

    //执行交互后返回timeline中的回调函数
    runJudgeFunction(judgeFunction, args, wxObj) {
        const that = this;
        const { parentNode } = this.state;
        let start_time = new Date().getTime();
        let use_time;
        let returnScore;

        if (parentNode.actionID === window.actionID) {
            that.roundNum++;
        } else {
            that.roundNum = 1;
        }
        window.actionID = parentNode.actionID;

        let localAsr = () => {
            returnScore = JSON.parse(window[judgeFunction](...args));
            use_time = new Date().getTime() - start_time;
            that.markGreen(args, wxObj, returnScore, judgeFunction, use_time);
        };
        that.judgeSpeechASR(args, wxObj)
            .then(responseJson => {
                if (responseJson && typeof responseJson === 'object' && responseJson.scores) {
                    args.push(JSON.stringify(responseJson));
                    localAsr();
                } else {
                    localAsr();
                }
            })
            .catch(error => {
                localAsr();
            });
    }

    //走网络判卷，本地js判卷用于兜底
    judgeSpeechASR(args, wxObj) {
        const that = this;
        return new Promise((resolve, reject) => {
            let opts = {
                method: 'POST',
                body: JSON.stringify({
                    requestID: wxObj.session_id + '',
                    putaoID: that.putaoid,
                    isASRFinished: args[4],
                    srcStr: args[1],
                    destStr: that.answerDetail,
                    round: that.roundNum,
                    form: "web",
                    speechResultMiddle_totalHit: that.speechResultMiddle_totalHit,
                }), //请求体
                headers: {},
            };
            fetch(new Request(`${reqUrl}/judgeSpeech/?requestID=${wxObj.session_id}`, opts))
                .then(response => {
                    //你可以在这个时候将Promise对象转换成json对象:response.json()
                    //转换成json对象后return，给下一步的.then处理
                    return response.json();
                })
                .then(responseJson => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    markGreen(args, wxObj, returnScore, judgeFunction, use_time) {
        const that = this;
        const { item, childCallback } = this.props;
        const { parentNode } = this.state;
        const resultInfo = returnScore.resultInfo;

        if (wxObj) {
            //标绿逻辑
            if (
                resultInfo &&
                resultInfo.is_markGreen &&
                resultInfo.speechResultMiddle_Hit &&
                resultInfo.speechResultMiddle_Hit instanceof Array &&
                resultInfo.speechResultMiddle_Hit.length
            ) {
                that.setState({
                    markGreen: true,
                    speechResultMiddle_Hit: resultInfo.speechResultMiddle_Hit,
                }, () => {
                    //给星星动画
                    for (let i = 0; i < resultInfo.speechResultMiddle_Hit.length; i++) {
                        let wordAni = document.getElementById('wordAni' + i);
                        if (wordAni && resultInfo.speechResultMiddle_Hit[i].hit === 1) {
                            lottie.loadAnimation({
                                container: wordAni,
                                renderer: 'svg',
                                loop: true,
                                autoplay: true,
                                path: window.animationUrl + 'asr_right.json',
                            });
                        }
                    }
                });
            }


            // 上报相关
            let reportEncourage = () => {
                // 给积分
                Utils.giveIntegrals(3, {
                    smileNum: resultInfo.smileNum || 0,
                    roundNum: that.roundNum
                });

                // 勋章上报
                Utils.encourageRecord(
                    {
                        cid: that.cid || Utils.getHashQueryString('url'),
                        startTime: window.startTime,
                        actionId: parentNode.actionID,
                        actionType: item.actionType,
                        fbType: '', //fbType,
                        score: returnScore.resultInfo.score || 0,
                        pageNum: window.curPageToReport || 0,
                        roundNum: that.roundNum, //轮数（第几轮回答，默认第一轮：1）
                        answer: that.answers && that.answers[0] ? that.answers[0] : '',
                        // "cnAnswer": ,   //中文答案
                        answerTime: that.answerTime, //答题的语音开口时长（单位：ms）
                        integrals: window.curIntegrals,
                    }
                );
            }

            // 处理回调
            if (childCallback && typeof childCallback === 'function') {
                if (window.needRecoRecordCourse) {
                    ReplayAction.add(window.keyStr, 'ASR_REPLAY_FEEDBACK', new Date().getTime() - window.recordPageTime, JSON.stringify(returnScore));
                    ReplayAction.commit(window.keyStr, 'ASRandJudge_');
                    window.keyStr += `.detail.timeline.nodes[${that.replayKeyNum}].actions[0]`;

                    that.handleAsrComplate(resultInfo.smileNum, () => {
                        reportEncourage();
                        childCallback(returnScore, ReplayAction.getScene());
                        ReplayAction.cleanScene();
                        setTimeout(() => {
                            that.removeAsrSay();
                        }, 500);
                    });
                } else {
                    that.handleAsrComplate(resultInfo.smileNum, () => {
                        reportEncourage();
                        childCallback(returnScore);
                        setTimeout(() => {
                            that.removeAsrSay();
                        }, 500);
                    });
                }
            }

            if (that.cid) {
                //生产系统预览没有cid，所以不上报以下数据

                //上报学习报告
                // Utils.reportRecord(window.startTime, item.actionID, item.actionType, "", returnScore.resultInfo.score || 0, item.knowledge);
                let cosKey = `$${wxObj.cos_date}$${that.putaoid}$${that.uuid}-web-main.wav`;
                Utils.newReportRecord(
                    {
                        cid: that.cid,
                        startTime: window.startTime,
                        actionId: parentNode.actionID,
                        actionType: item.actionType,
                        fbType: '', //fbType,
                        score: returnScore.resultInfo.score || 0,
                        pageNum: window.curPageToReport || 0,
                        roundNum: that.roundNum, //轮数（第几轮回答，默认第一轮：1）
                        answer: that.answers && that.answers[0] ? that.answers[0] : '',
                        // "cnAnswer": ,   //中文答案
                        answerTime: that.answerTime, //答题的语音开口时长（单位：ms）
                        answerSoundUrl: `https://course-wavs-1256571289.cos.ap-beijing.myqcloud.com/${that.cid}/${encodeURIComponent(cosKey)}`,
                    },
                    {
                        knowledge: item.knowledge,
                    }
                );

                //上报pingBack
                Utils.postPingBack({
                    actionID: parentNode.actionID,
                    answer: args[2],
                    asr_function: judgeFunction,
                    cost: use_time / 1000, //执行函数的时间:s
                    courseId: that.cid,
                    isASRFinished: 1,
                    putaoid: that.putaoid,
                    retryTimes: args[3],
                    score: JSON.stringify(returnScore.resultInfo) || 0,
                    uigs_productid: 'main_course',
                    uigs_t: wxObj.cos_date,
                    uigs_type: 'judgeASR',
                    uigs_uuid: that.uuid,
                    wechatSessionID: wxObj.session_id,
                    from: 'pc',
                    result: args[1],
                });

                //上传音频到腾讯云
                if (recorder && process.env.NODE_ENV !== 'development') {
                    var record = recorder.getBlob();
                    // console.log('cos:', record)
                    Cos.uploadCos(record, {
                        cid: that.cid,
                        putaoid: that.putaoid,
                        uuid: that.uuid,
                        session_id: wxObj.session_id,
                        result: `format1.0:${args[1]}$$$${args[2]}$$$${JSON.stringify(returnScore.resultInfo)}`,
                        cosDate: wxObj.cos_date,
                    });
                }
            }
        } else {
            if (returnScore && returnScore.isFinished === 1) {
                that.handleCompleteAsr();

                that.handleAsrComplate(resultInfo.smileNum, () => {
                    childCallback(returnScore, null);
                    setTimeout(() => {
                        that.removeAsrSay();
                    }, 500);
                });
            }
        }
    }

    /**
     * maxTime 录音时长
     * judgeFunction 录音完的回调
     * parentNode 获取参数的父节点
     */
    startRecording() {
        const that = this;
        //上报pb和上传音频用的时间格式
        let session_id = new Date().getTime();
        let myDate = (that.startReacordTime = new Date());
        let cos_date = `${myDate.getFullYear()}${myDate.getMonth() < 9 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1}${myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()
            }${myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours()}${myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes()}${myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds()
            }`;

        setTimeout(() => {
            //话筒出来的动画时间
            WebRTC.getHZRecorder(function (rec) {
                recorder = rec;
                recorder.start();
            });

            that.setState({
                arsJudgeStatus: 1,
            }, () => {
                // 开始录音之后，隔一会就更新当前的最大值
                let volumn2s = []; //存放2s的音频数据，用户做静音检测自动结束
                let volumn5s = []; //存放5s的音频数据，用户做静音检测出tips
                let volumnTips = document.getElementById('volumnTips');
                if (volumnTips) {
                    that.maxVolumnTimer = setInterval(() => {
                        let volumn = Math.floor((window.maxVolumn / 1.5) * 70);
                        // console.log('volumn:', volumn)
                        let volumnArr = [];
                        for (let i = 0; i < 11; i++) {
                            volumnArr.push(volumn > this.minVolumn ? Utils.randomFrom(10, Math.min(volumn, 45)) : 5);
                        }

                        //当有声音以后，不在出静音提示
                        if (volumn > 15) {
                            that.volumnState = 1;

                            //静音检测，每2s检测前2s的平均值，小于 that.minVolumn 出提示
                            clearInterval(that.avgVolumnTimer);
                            that.avgVolumnTimer = setInterval(() => {
                                // console.log('arrayAvg:', volumn2s, Utils.arrayAvg(volumn2s));
                                let avg = Utils.arrayAvg(volumn2s); //声音平均值
                                // console.log(avg)
                                if (avg > that.minVolumn && that.volumnState !== 2) {
                                    that.volumnState = 1;
                                } else if (avg <= that.minVolumn && that.volumnState === 1) {
                                    that.volumnState = 2;
                                }
                                // else if (avg <= that.minVolumn && that.volumnState === -1) {
                                //     that.volumnState = 0;
                                // }
                                volumn2s = [];
                                volumnTips.setAttribute('class', 'hide');
                            }, 2000); //静音检测2s改成1s
                        }

                        that.setState({
                            volumnWave: volumnArr,
                        });
                        volumn2s.push(volumn || 0);
                        volumn5s.push(volumn || 0);
                    }, 100);

                    //第5s检测静音，静音出提示
                    setTimeout(() => {
                        let avg = Utils.arrayAvg(volumn5s); //声音平均值
                        if (avg <= that.minVolumn && that.volumnState < 1 && !that.speechResultMiddle) {
                            volumnTips.setAttribute('class', '');
                        } else {
                            volumnTips.setAttribute('class', 'hide');
                        }
                    }, 5000);
                }

                if (that.maxTime) {
                    let interTime = 0;
                    let sendSpeed = 0.25; //发送包的频率，s
                    let sendTotal = 0;
                    that.obtainRecordInterval = setInterval(() => {
                        sendTotal++;
                        interTime = interTime + sendSpeed;
                        // console.log('interTime:', interTime)
                        // console.log('is:', (interTime >= maxTime || that.volumnState === 2) ? 1 : 0)
                        if (interTime >= that.maxTime || that.volumnState === 2) {
                            //结束条件：超过最大时间 || 说过话后超过2s是静音状态
                            that.stopRecord();
                            clearInterval(that.obtainRecordInterval);
                            clearInterval(that.avgVolumnTimer);
                        }
                        that.audioFileReader(interTime, {
                            session_id: session_id, //当前时间戳，每次发的保证一致
                            seq_id: sendTotal - 1, //第几个包，需要从0开始
                            is_finished: interTime >= that.maxTime || that.volumnState === 2 || that.endAsrStop ? 1 : 0,
                            cos_date: cos_date,
                        });

                        // 倒计时3s，一直静音的情况出
                        const asrCountdown = document.getElementById('asrCountdown');
                        if (!that.showText && asrCountdown && that.maxTime - interTime < 3 && that.volumnState < 2) {
                            //跟读去掉倒计时20190529
                            asrCountdown.innerText = Math.ceil(that.maxTime - interTime);
                        }
                    }, sendSpeed * 1000);
                }
            });

            //录屏相关代码
            if (window.needRecoRecordCourse) {
                if (!(window.g_currentScene && window.g_currentScene.timeline)) {
                    ReplayAction.setScene(JSON.stringify(window.curPageSceneList));
                }
                ReplayAction.add(
                    window.keyStr,
                    'ASR_REPLAY_BEGIN',
                    new Date().getTime() - window.recordPageTime,
                    JSON.stringify({
                        voiceUrl: `https://course-wavs-1256571289.cos.ap-beijing.myqcloud.com/${that.cid}/$${cos_date}$${that.putaoid}$${that.uuid}-web-main.wav`,
                    })
                );
            }
        }, 500);
    }
    stopRecord() {
        const that = this;
        const { parentNode, currStarCount, currSubjectCount } = this.state;

        that.clearAnimation();
        clearInterval(that.maxVolumnTimer);
        clearInterval(that.avgVolumnTimer);
        that.setState({
            arsJudgeStatus: 2,
            asrComplete: that.showText ? false : true, //不是跟读，直接结束
        });
        if (recorder) {
            recorder.stop();
        }

        that.answerTime = new Date() - that.startReacordTime;

        if (!recorder && window.isDev && that.judgeFunction) {
            that.runJudgeFunction(
                that.judgeFunction,
                [
                    parentNode.actionID,
                    '', //result 识别的结果,
                    that.answerDetail, //正确答案
                    parentNode.detail.retryTimes, //retryTimes,
                    1, //isASRFinished,
                    currStarCount, //currStarCount,当前星星数
                    currSubjectCount, //currSubjectCount  当前题目数（有starSubject=1的时候就加1）
                ],
                null
            ); //原始的讯飞返回给pb用，方便查问题
        }
    }
    //读取音频文件 Base64
    audioFileReader(interTime, wxObj) {
        const that = this;
        const { item, childCallback } = this.props;
        const { parentNode, currStarCount, currSubjectCount } = this.state;
        // console.log(interTime)

        const reader = new FileReader();
        if (recorder) {
            var record = recorder.getBlob(interTime);
            // console.log(record)
            // document.getElementById('file_selector').value = record;
            reader.readAsDataURL(record);
            reader.onload = function () {
                // $('#audioTest').append('<audio src="' + reader.result + '" style="height:30px"  controls autoPlay></audio>')
                let base64Result = reader.result.replace('data:audio/wav;base64,', '');

                if (wxObj && wxObj.is_finished === 1) {
                    clearInterval(that.obtainRecordInterval);
                    clearInterval(that.avgVolumnTimer);
                    //同时发送讯飞和微信
                    let postASRList = [];
                    let postASRNameList = [];
                    let resultDetail = {};
                    let results = {};
                    let pro1;
                    let pro2;
                    let pro3;
                    let tryGetResultsTime = 0; //获取返回结果的重试次数
                    if (that.speechServices2 && that.speechServices2.length) {
                        for (let i = 0; i < that.speechServices2.length; i++) {
                            let serverName = that.speechServices2[i].serverName || '';
                            if (serverName === 'xunfeiASR') {
                                postASRNameList.push('xunfeiASR');
                                pro1 = that.postIfyAudio().then(res => {
                                    results['xunfeiASR'] = res;
                                });
                            } else if (serverName === 'wechatASE') {
                                postASRNameList.push('wechatASE');
                                pro2 = that.postWXAudio(wxObj, base64Result).then(res => {
                                    results['wechatASE'] = res;
                                });
                            } else if (serverName === 'putaoASR') {
                                postASRNameList.push('putaoASR');
                                pro3 = that.postPTAudio(wxObj, base64Result).then(res => {
                                    results['putaoASR'] = res;
                                });
                            }
                        }
                    } else {
                        pro1 = that.postIfyAudio();
                        pro2 = that.postWXAudio(wxObj, base64Result);
                    }

                    let getResults = () => {
                        // 调用录音返回函数
                        let ixfData =
                            results['xunfeiASR'] && typeof results['xunfeiASR'] === 'string' && results['xunfeiASR'].length
                                ? JSON.parse(results['xunfeiASR']).data
                                : '';

                        //封装resultDetail
                        if (postASRNameList && postASRNameList.length) {
                            for (let i = 0; i < postASRNameList.length; i++) {
                                let serverName = postASRNameList[i];
                                if (serverName === 'xunfeiASR') {
                                    if (!(resultDetail['xunfeiASR'] && resultDetail['xunfeiASR'] instanceof Array)) {
                                        resultDetail['xunfeiASR'] = [];
                                    }
                                    resultDetail['xunfeiASR'].push({ result: ixfData, refTextID: 0, refText: '', otherInfo: {} });
                                } else if (serverName === 'wechatASE') {
                                    if (!(resultDetail['wechatASE'] && resultDetail['wechatASE'] instanceof Array)) {
                                        resultDetail['wechatASE'] = [];
                                    }
                                    if (that.answers && that.answers.length) {
                                        for (let j = 0; j < that.answers.length; j++) {
                                            resultDetail['wechatASE'].push({
                                                result: results['wechatASE'],
                                                refTextID: j,
                                                refText: that.answers[j],
                                                otherInfo: {},
                                            });
                                        }
                                    } else {
                                        resultDetail['wechatASE'].push({
                                            result: results['wechatASE'],
                                            refTextID: 0,
                                            refText: item.detail.answer || '',
                                            otherInfo: {},
                                        });
                                    }
                                } else if (serverName === 'putaoASR') {
                                    if (!(resultDetail['putaoASR'] && resultDetail['putaoASR'] instanceof Array)) {
                                        resultDetail['putaoASR'] = [];
                                    }
                                    resultDetail['putaoASR'].push({ result: results['putaoASR'], refTextID: 0, refText: '', otherInfo: {} });
                                }
                            }
                            resultDetail = JSON.stringify(resultDetail);
                        } else {
                            resultDetail = `${ixfData}||${results['wechatASE']}`;
                        }

                        // try {
                        if (that.judgeFunction) {
                            that.runJudgeFunction(
                                that.judgeFunction,
                                [
                                    parentNode.actionID,
                                    resultDetail, //result 识别的结果,
                                    that.answerDetail, //正确答案
                                    parentNode.detail.retryTimes, //retryTimes,
                                    1, //isASRFinished,
                                    currStarCount, //currStarCount,当前星星数
                                    currSubjectCount, //currSubjectCount  当前题目数（有starSubject=1的时候就加1）
                                ],
                                wxObj
                            ); //原始的讯飞返回给pb用，方便查问题
                        }
                        // } catch (err) {

                        // }
                    };

                    let tryGetResults = () => {
                        if (Object.keys(results).length === postASRNameList.length || tryGetResultsTime > 50) {
                            getResults();
                        } else {
                            setTimeout(() => {
                                tryGetResultsTime++;
                                tryGetResults();
                            }, 100);
                        }
                    };

                    tryGetResults();

                    // Promise.all(postASRList).then(function (results) {
                    //     //调用录音返回函数
                    //     let ixfKey = Utils.getItemKeyInArrayObject(postASRNameList, "xunfeiASR");
                    //     let ixfData = results[ixfKey] && typeof results[ixfKey] === 'string' && results[ixfKey].length ? JSON.parse(results[ixfKey]).data : "";
                    //     // let result = `${ixfData}||${results[1]}`;

                    //     //封装resultDetail
                    //     if (postASRNameList && postASRNameList.length) {
                    //         for (let i = 0; i < postASRNameList.length; i++) {
                    //             let serverName = postASRNameList[i];
                    //             if (serverName === "xunfeiASR") {
                    //                 if (!(resultDetail["xunfeiASR"] && resultDetail["xunfeiASR"] instanceof Array)) {
                    //                     resultDetail["xunfeiASR"] = [];
                    //                 }
                    //                 resultDetail["xunfeiASR"].push({ "result": ixfData, "refTextID": 0, "refText": "", "otherInfo": {} });
                    //             } else if (serverName === "wechatASE") {
                    //                 if (!(resultDetail["wechatASE"] && resultDetail["wechatASE"] instanceof Array)) {
                    //                     resultDetail["wechatASE"] = [];
                    //                 }
                    //                 if (that.answers && that.answers.length) {
                    //                     for (let j = 0; j < that.answers.length; j++) {
                    //                         resultDetail["wechatASE"].push({ "result": results[Utils.getItemKeyInArrayObject(postASRNameList, "wechatASE")], "refTextID": j, "refText": that.answers[j], "otherInfo": {} });
                    //                     }
                    //                 } else {
                    //                     resultDetail["wechatASE"].push({ "result": results[Utils.getItemKeyInArrayObject(postASRNameList, "wechatASE")], "refTextID": 0, "refText": item.detail.answer || '', "otherInfo": {} });
                    //                 }
                    //             } else if (serverName === "putaoASR") {
                    //                 if (!(resultDetail["putaoASR"] && resultDetail["putaoASR"] instanceof Array)) {
                    //                     resultDetail["putaoASR"] = [];
                    //                 }
                    //                 resultDetail["putaoASR"].push({ "result": results[Utils.getItemKeyInArrayObject(postASRNameList, "putaoASR")], "refTextID": 0, "refText": "", "otherInfo": {} });
                    //             }
                    //         }
                    //         // console.log('results:', resultDetail)
                    //         resultDetail = JSON.stringify(resultDetail);
                    //     } else {
                    //         resultDetail = `${ixfData}||${results[1]}`;
                    //     }

                    //     if (that.judgeFunction) {
                    //         that.runJudgeFunction(that.judgeFunction, [
                    //             parentNode.actionID,
                    //             resultDetail, //result 识别的结果,
                    //             that.answerDetail, //正确答案
                    //             parentNode.detail.retryTimes, //retryTimes,
                    //             1, //isASRFinished,
                    //             currStarCount, //currStarCount,当前星星数
                    //             currSubjectCount, //currSubjectCount  当前题目数（有starSubject=1的时候就加1）
                    //         ], wxObj);  //原始的讯飞返回给pb用，方便查问题
                    //     }
                    // }).catch(function (err) {
                    //     console.log('post asr', err);
                    //     childCallback({});
                    // });

                    // if (that.state.arsJudgeStatus === 1) {
                    that.stopRecord();
                    // }
                } else {
                    that.postWXAudio(wxObj, base64Result);
                    that.postPTAudio(wxObj, base64Result);
                }
            };
        }
    }
    playRecord() {
        if (recorder) {
            recorder.play(document.getElementById('playOnAudio'));
        }
    }

    //发送到讯飞评测接口
    postIfyAudio() {
        return new Promise((resolve, reject) => {
            const that = this;
            const reader = new FileReader();
            if (recorder) {
                var record = recorder.getBlob();
                reader.readAsDataURL(record);
                reader.onload = function () {
                    let opts = {
                        method: 'POST',
                        body: reader.result.replace('data:audio/wav;base64,', ''), //请求体
                        headers: {},
                    };
                    // $('#playOnAudio').attr('src', reader.result)

                    fetch(new Request(`${reqUrl}/sogouSE/ify?_=${Math.random()}`, opts))
                        .then(response => {
                            //你可以在这个时候将Promise对象转换成json对象:response.json()
                            //转换成json对象后return，给下一步的.then处理
                            return response.text();
                        })
                        .then(responseText => {
                            resolve(responseText);
                        })
                        .catch(error => {
                            console.log('error:', error);
                        });
                };
            } else {
                that.handleFailGetRecorder();
            }
        });
    }

    //发送到微信评测接口
    postWXAudio(wxObj, base64Result) {
        const { item } = this.props;
        const answer = item.detail.answer;
        return new Promise((resolve, reject) => {
            let opts = {
                method: 'POST',
                body: base64Result, //请求体
                headers: {},
            };
            // $('#audioTest').append('<audio src="data:audio/wav;base64,' + base64Result + '" style="height:30px"  controls autoPlay></audio>')

            fetch(
                new Request(
                    `${reqUrl}/sogouSE/wx?_=${Math.random()}&session_id=${wxObj.session_id}&seq_id=${wxObj.seq_id}&is_finished=${wxObj.is_finished
                    }&ref_text=${encodeURIComponent(answer)}`,
                    opts
                )
            )
                .then(response => {
                    //你可以在这个时候将Promise对象转换成json对象:response.json()
                    //转换成json对象后return，给下一步的.then处理
                    return response.text();
                })
                .then(responseText => {
                    resolve(responseText);
                })
                .catch(error => {
                    reject(error);
                    console.log('error:', error);
                });
        });
    }

    //发送到葡萄评测接口
    postPTAudio(wxObj, base64Result) {
        const that = this;
        return new Promise((resolve, reject) => {
            let opts = {
                method: 'POST',
                body: JSON.stringify({
                    "seqID": wxObj.seq_id,
                    "sessionID": wxObj.session_id,
                    "isEnd": wxObj.is_finished,
                    "voiceDataInBase64": base64Result,
                    "requestID": wxObj.session_id,
                    "userID": that.putaoid,
                    "speechInfo": that.getSpeechInfo('putaoASR') ? that.getSpeechInfo('putaoASR') : { "type": "ASR", "text": that.answers && that.answers[0] ? that.answers[0] : "" }
                }),   //请求体 
                headers: {},
            };
            // $('#audioTest').append('<audio src="data:audio/wav;base64,' + base64Result + '" style="height:30px" controls></audio>')

            fetch(new Request(`${reqUrl}/speechService/?sessionID=${wxObj.session_id}`, opts))
                .then(response => {
                    //你可以在这个时候将Promise对象转换成json对象:response.json()
                    //转换成json对象后return，给下一步的.then处理
                    return response.text();
                })
                .then(responseText => {
                    //抖动逻辑
                    try {
                        const parseRes = JSON.parse(responseText);
                        const hit = parseRes.speechResultMiddle_Hit;
                        const info = parseRes.speechResultMiddle_info;
                        that.speechResultMiddle = parseRes.speechResultMiddle || that.speechResultMiddle;
                        if (hit && hit instanceof Array && hit.length) {
                            that.setState({
                                speechResultMiddle_Hit: hit,
                            });

                            // 取标绿过的交集
                            that.handleSpeechResultMiddleHit(hit);

                            //录屏相关代码
                            if (window.needRecoRecordCourse) {
                                ReplayAction.add(window.keyStr, 'ASR_REPLAY_HITS', new Date().getTime() - window.recordPageTime, JSON.stringify({ hits: hit }));
                                that.replayKeyNum++;
                            }
                        }
                        if (info && typeof info === "object") {
                            // 尾端静音 || 首端静音
                            if ((info["end-over"] === 1 && info["sil-dur"] > 1) || (info["start-over"] === 1 && info["sil-dur"] > 10)) {
                                that.endAsrStop = true;
                            }
                        }
                    } catch (err) {
                        console.log(err)
                    }

                    // 每次发给判卷函数，如果判卷结果isFinised=1，直接结束
                    // let resultDetail = {};
                    // if (!(resultDetail["putaoASR"] && resultDetail["putaoASR"] instanceof Array)) {
                    //     resultDetail["putaoASR"] = [];
                    // }
                    // resultDetail["putaoASR"].push({ "result": responseText, "refTextID": 0, "refText": "", "otherInfo": {} });
                    // if (that.judgeFunction) {
                    //     that.runJudgeFunction(that.judgeFunction, [
                    //         parentNode.actionID,
                    //         JSON.stringify(resultDetail), //result 识别的结果,
                    //         that.answerDetail, //正确答案
                    //         parentNode.detail.retryTimes, //retryTimes,
                    //         0, //isASRFinished,
                    //         currStarCount, //currStarCount,当前星星数
                    //         currSubjectCount, //currSubjectCount  当前题目数（有starSubject=1的时候就加1）
                    //     ]);  //原始的讯飞返回给pb用，方便查问题
                    // }

                    resolve(responseText);
                })
                .catch(error => {
                    reject(error);
                    console.log('error:', error);
                });
        });
    }

    handleSpeechResultMiddleHit(hit) {
        const that = this;
        that.speechResultMiddle_totalHit = [...(that.speechResultMiddle_totalHit || hit)].filter(x => [...hit].filter(y => {
            if (y.hit === 1 && x.word === y.word) {
                x.hit = 1;
            }
        }));
    }

    getSpeechInfo(type) {
        const that = this;
        if (that.speechServices2 && that.speechServices2 instanceof Array && that.speechServices2.length) {
            let speechServices2 = that.speechServices2;
            let speechInfo = '';
            for (let i = 0; i < speechServices2.length; i++) {
                let speechServices = speechServices2[i];
                if (speechServices.serverName === type && speechServices.params && speechServices.params.speechInfo && speechServices.params.speechInfo.text) {
                    speechInfo = speechServices.params.speechInfo;
                }
            }
            return speechInfo;
        }
    }

    //有一次合电脑待机第二天早上获取不到浏览器录音 recorder
    handleFailGetRecorder() {
        alert('无法获取您的录音数据，请关闭浏览器重试！');
    }

    handleCompleteAsr() {
        this.volumnState = 2;
    }

    render() {
        const that = this;
        const { arsJudgeStatus, volumnWave, speechResultMiddle_Hit, asrComplete, markGreen, showFlower } = this.state;
        return (
            <div
                id='asrSay'
                className={asrComplete ? 'clear-bg' : arsJudgeStatus === 2 ? 'asr-out' : 'asr-say'}
                style={{
                    zoom: window.mainSize.percent,
                }}
            >
                {arsJudgeStatus === 1 ? (
                    <div id='volumnTips' className='hide'>
                        没有听到您的声音，请大声，或检查麦克风设置。
                    </div>
                ) : null}
                {!asrComplete ? (
                    <div className='micro'>
                        <ul className='wave'>
                            {volumnWave.map((item, index) => {
                                return <li key={index} style={{ height: `${item}px`, marginTop: `${22 - item / 2}px` }} />;
                            })}
                        </ul>
                        <ul className='wave2'>
                            {volumnWave.map((item, index) => {
                                return <li key={index} style={{ height: `${item}px`, marginTop: `${22 - item / 2}px` }} />;
                            })}
                        </ul>
                        <div id='asrCountdown' />
                        {/* <div id="asrComplete" onClick={() => that.handleCompleteAsr()}>说完了</div> */}

                        {/* <div id="asrTimeSpeed" className="asr-time-speed" style={{ "width": "100%" }} /> */}
                    </div>
                ) : null}

                {!showFlower && !asrComplete && that.showText && (arsJudgeStatus === 1 || arsJudgeStatus === 2) ? (
                    <div id='showText'>
                        {speechResultMiddle_Hit && speechResultMiddle_Hit.length ? (
                            <div className='table-cell'>
                                {speechResultMiddle_Hit.map((speechResult, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={
                                                speechResult.hit
                                                    ? arsJudgeStatus === 1
                                                        ? 'word word-big'
                                                        : markGreen
                                                            ? 'word word-green'
                                                            : 'word'
                                                    : markGreen
                                                        ? 'word word-red'
                                                        : 'word'
                                            }
                                        >
                                            <div id={'wordAni' + index} className='word-ani' />
                                            {speechResult.word}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className='table-cell'>
                                {that.showText
                                    ? that.showText.split(' ').map((text, index) => {
                                        return (
                                            <div className='word' key={index}>
                                                {text}
                                            </div>
                                        );
                                    })
                                    : null}
                            </div>
                        )}
                    </div>
                ) : null}
                <audio id='playAsrAudio' src='' autoPlay />
            </div>
        );
    }
}

export default ASRandJudge;



// WEBPACK FOOTER //
// ./src/components/on/ASRandJudge.js